// PercentageChart.jsx
import React from "react";
import { VictoryPie, VictoryLabel } from "victory";

const PercentageChart = ({ percentage }) => {
  // Ensure percentage is a valid number between 0-100
  const validPercentage = Math.min(Math.max(0, Number(percentage) || 0), 100);
  
  // Determine color based on percentage
  const getColor = (percent) => {
    if (percent >= 70) return "#28a745"; // Green for high match
    if (percent >= 40) return "#ffc107"; // Yellow for medium match
    return "#dc3545"; // Red for low match
  };
  
  const color = getColor(validPercentage);
  
  // Handle edge cases for the chart data
  const data = validPercentage === 100 
    ? [{ x: 1, y: 100 }] 
    : [
        { x: 1, y: validPercentage },
        { x: 2, y: 100 - validPercentage }
      ];

  return (
    <div className="chart-wrapper">
      <svg viewBox="0 0 200 200" width="100%" height="100%">
        <VictoryPie
          standalone={false}
          width={200}
          height={200}
          data={data}
          innerRadius={60}
          cornerRadius={5}
          labels={() => null}
          style={{
            data: {
              fill: ({ datum }) => (datum.x === 1 ? color : "#f0f0f0"),
            },
          }}
          animate={{
            duration: 1000, // Reduced animation time
            onEnter: {
              duration: 500,
              before: () => ({ opacity: 0 }),
              after: () => ({ opacity: 1 }),
            },
          }}
        />
        <VictoryLabel
          textAnchor="middle"
          verticalAnchor="middle"
          x={100}
          y={100}
          text={`${Math.round(validPercentage)}%`}
          style={{ fontSize: 24, fontWeight: "bold", fill: color }}
        />
      </svg>
    </div>
  );
};

export default PercentageChart;